module.exports = __webpack_public_path__ + "static/media/user-icon.ad33716d.svg";